<template>
  <div
    class="screen"
    v-touch:swipe.bottom="openCreateForm"
    v-touch:swipe.top="closeCreateForm"
  >
    <div class="container">
      <button
        @click="isCreateFormOpened = !isCreateFormOpened"
        :class="{ 'add-close': isCreateFormOpened }"
        class="add"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="512"
          height="512"
          viewBox="0 0 512 512"
        >
          <line
            x1="256"
            y1="112"
            x2="256"
            y2="400"
            stroke="#000"
            style="fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"
          />
          <line
            x1="400"
            y1="256"
            x2="112"
            y2="256"
            stroke="#000"
            style="fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"
          />
        </svg>
      </button>
      <transition name="slide">
        <Form @submit="add" v-if="isCreateFormOpened" title="New day">
          <input
            required
            v-model.trim="createName"
            placeholder="Name"
            class="form-control"
            type="text"
          />
          <input
            required
            v-model.trim="createDate"
            placeholder="Date"
            class="form-control"
            type="datetime-local"
          />
          <button class="form-control">Submit</button>
        </Form>
      </transition>
      <transition name="modal">
        <Modal :toggleModal="toggleModal" v-if="isEditModalOpened">
          <Form
            @submit="edit(currentIndex)"
            :title="'Edit ' + items[currentIndex].name"
          >
            <input
              required
              v-model.trim="editName"
              placeholder="Name"
              class="form-control"
              type="text"
            />
            <input
              required
              v-model.trim="editDate"
              placeholder="Date"
              class="form-control"
              type="datetime-local"
            />
            <button class="form-control">Submit</button>
          </Form>
        </Modal>
      </transition>
      <transition-group class="items" name="list" tag="div">
        <Item
          @remove="remove(index)"
          @edit="toggleModal(index)"
          @open="open(index)"
          :key="item.id"
          v-for="(item, index) in items"
          :name="item.name | capitalize"
          :date="item.date | capitalize"
        >
        </Item>
      </transition-group>
      <transition name="fade">
        <p class="empty-text" v-if="items.length === 0 && !isCreateFormOpened">
          Add your new timer
        </p>
      </transition>
    </div>
  </div>
</template>

<script>
import Item from "./Item";
import Form from "./Form";
import Modal from "./Modal";
import store from "../store/index";
import Vue from "vue";
import Vue2TouchEvents from "vue2-touch-events";

Vue.use(Vue2TouchEvents);

export default {
  name: "Dashboard",
  store,
  components: {
    Item,
    Form,
    Modal
  },
  data() {
    return {
      items: store.state.items,
      isCreateFormOpened: false,
      isEditModalOpened: false,
      currentIndex: null,
      createName: "",
      createDate: "",
      editName: "",
      editDate: ""
    };
  },
  methods: {
    openCreateForm() {
      this.isCreateFormOpened = true;
    },
    closeCreateForm() {
      this.isCreateFormOpened = false;
    },
    toggleModal(index) {
      this.isEditModalOpened = !this.isEditModalOpened;

      if (this.isEditModalOpened) {
        this.currentIndex = index;

        let item = this.items[this.currentIndex];

        this.editName = item.name;
        this.editDate = item.date;
      }
    },
    edit(index) {
      let validDate = Date.parse(this.editDate) > Date.now(); // ensure timer looks in the future

      if (this.editName && validDate) {
        store.commit("edit", {
          index,
          name: this.editName,
          date: this.editDate
        });

        this.editName = "";
        this.editDate = "";
        this.toggleModal();
      }
    },
    remove(index) {
      store.commit("remove", { index });
    },
    open(index) {
      store.commit("open", { index });
    },
    add() {
      let validDate = Date.parse(this.createDate) > Date.now(); // ensure timer looks in the future

      if (this.createName && validDate) {
        let latestId = Math.max.apply(
          Math,
          store.state.items.map(o => o.id)
        );

        store.commit("add", {
          id: latestId + 1,
          name: this.createName,
          date: this.createDate,
          done: false
        });

        this.createName = "";
        this.createDate = "";
        this.isCreateFormOpened = !this.isCreateFormOpened;
      }
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
};
</script>

<style scoped>
.items {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: var(--gutter);
}

.add {
  background: rgb(var(--gray-4));
}

.add:hover {
  opacity: 0.8;
}

.add {
  margin: var(--gutter) 0;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  border: none;
  font-size: 0;
  transition: var(--smooth-fast);
}

.add svg {
  width: 1rem;
  height: 1rem;
}

.add svg line {
  stroke: rgb(var(--text-1));
}

.add-close {
  transform: rotate(45deg);
}

.modal-enter-active,
.modal-leave-active {
  transition: var(--smooth-slow);
}

.modal-enter,
.modal-leave-to {
  opacity: 0;
  transform: translate(-50%, -100%) scale(0.8);
}

.slide-enter-active,
.slide-leave-active {
  transition: var(--smooth-slow);
  max-height: 203px;
}

.slide-enter,
.slide-leave-to {
  transform: scale(0.8);
  opacity: 0;
  max-height: 0;
  margin: 0;
}

.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}

.list-leave-active {
  position: absolute;
}

.fade-enter-active,
.fade-leave-active {
  transition: var(--smooth-slow);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.empty-text {
  position: absolute;
  color: rgb(var(--text-2));
}
</style>
